module.exports = __webpack_public_path__ + "static/media/automation.7c4fc9d4.png";